const sections = [
  {
    number: "001",
    i18nKey: "Navigation.about",
  },
  {
    number: "002",
    i18nKey: "Navigation.skills",
  },
  {
    number: "003",
    i18nKey: "Navigation.works",
  },
  {
    number: "004",
    i18nKey: "Navigation.contact",
  },
  {
    number: "000",
    i18nKey: "Navigation.navigation",
  },
];

export default sections;
